export default __webpack_public_path__ + "assets/images/2e84cb7f51e2a3adab428d37002fa88f.png";